import { render, staticRenderFns } from "./AllPermissionSidebar.vue?vue&type=template&id=65536241&scoped=true&"
import script from "./AllPermissionSidebar.vue?vue&type=script&lang=js&"
export * from "./AllPermissionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AllPermissionSidebar.vue?vue&type=style&index=0&id=65536241&lang=scss&scoped=true&"
import style1 from "./AllPermissionSidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65536241",
  null
  
)

export default component.exports